import { Avatar, Fab, FormHelperText, InputAdornment, List, ListItem, ListItemAvatar, ListItemText, OutlinedInput, Snackbar, TextField, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import AddIcon from '@mui/icons-material/Add';
import {Button} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import "dayjs/locale/pt-br";
import MuiAlert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import api from '../../../../services/api';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import './styles.css'
import { IconContext } from 'react-icons';
import { AiOutlineClose } from 'react-icons/ai';

function SolicitarColetaExtra({user, getStart, setLoading}) {
  const theme = useTheme();
  let idContrato = user.idContrato;
  const [activeStep, setActiveStep] = useState(0);
  const [show, setShow] = useState(false);
  const [dataMinimo, setDataMinimo] = useState();
  const [dataMaximo, setDataMaximo] = useState();
  let date = new Date();
  let date2 = new Date();
  date.setDate(date.getDate() + 1);
  date2.setDate(date2.getDate() + 30);
  let ano = date.getFullYear();
  var mes = ("0" + (date.getMonth() + 1)).substr(-2);
  var dia = ("0" + date.getDate()).substr(-2);
  useEffect(() => {
    setDataMinimo(date);
    setDataMaximo(date2)
    verifyDate(ano + "-" + mes + "-" + dia)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idContrato]);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [value, setValue] = useState("");
  const [text, setText] = useState(ano + "-" + mes + "-" + dia);
  const [data, setData] = useState('');
  const [quantidade, setQuantidade] = useState("");
  const [items, setItems] = useState([
    {
        label: 'Selecione a data',
        value: '',
        disabled: true,
    },
  ]);
  const [alerta, setAlerta] = useState(
    {
        type: 'error',
        msg: '',
        show: false,
    },
  );
  const verifyDate = (date) => {
    let temp = String(date).split('-');
    let ano = temp[0];
    let mes = temp[1];
    let dia = temp[2];
    let dateTemp = new Date();
    var hours = new Date().getHours();
    dateTemp.setDate(dateTemp.getDate() + 1);
    let dateVerifyTomorow = dateTemp.getFullYear()+ '-' +("0" + (dateTemp.getMonth() + 1)).substr(-2) + '-' + ("0" + dateTemp.getDate()).substr(-2);
    let dateVerify = ano + '-' +("0" + mes).substr(-2) + '-' + ("0" + dia).substr(-2);
    if(dateVerifyTomorow === dateVerify){
      if(hours >= 17){
          setItems([
              {
                  label: 'Tarde - 14h ás 23:48h',
                  value: 'Tarde - 14h ás 23:48h',
                  disabled: false
              },
              {
                  label: 'Noite - 18h ás 04:48h',
                  value: 'Noite - 18h ás 04:48h',
                  disabled: false
              },
          ]);
      }else{
        setItems([
          {
              label: 'Manhã - 5h ás 14:48',
              value: 'Manhã - 5h ás 14:48',
              disabled: false
          },
          {
              label: 'Tarde - 14h ás 23:48h',
              value: 'Tarde - 14h ás 23:48h',
              disabled: false
          },
          {
              label: 'Noite - 18h ás 04:48h',
              value: 'Noite - 18h ás 04:48h',
              disabled: false
          },
        ]);
      }
    }else{
      setItems([
        {
            label: 'Manhã - 5h ás 14:48',
            value: 'Manhã - 5h ás 14:48',
            disabled: false
        },
        {
            label: 'Tarde - 14h ás 23:48h',
            value: 'Tarde - 14h ás 23:48h',
            disabled: false
        },
        {
            label: 'Noite - 18h ás 04:48h',
            value: 'Noite - 18h ás 04:48h',
            disabled: false
        },
      ]);
    }
  }
  const handleChangeData = (date) => {
    let {$D, $M , $y} = date
    let mes = $M/1;
    let dia = $D/1;
    mes++;
    if(mes < 10){
      mes = '0' + mes;
    }
    if(dia < 10){
      dia = '0' + dia;
    }
    setText($y + "-" + mes + "-" + dia);
    verifyDate($y + "-" + mes + "-" + dia)
  };
  const handleChangeTurno = (event) => {
    setValue(event.target.value);
  };
  const handleChangeQuantidade = (event) => {
    setQuantidade(event.target.value);
  };
  const confirmar = () => {
    if(text != null && text !== '' && value != null  && value !== '' && quantidade != null  && quantidade !== '' && quantidade !== '0' && quantidade !== 0){
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      let tempDate = text.split('-');

      setData(tempDate[2] + "/" + tempDate[1] + "/" +tempDate[0])
    }else{
      setAlerta({
        type: 'error',
        msg: 'Preencha todos os campos!',
        show: true,
      });
    }
  }
  const soliticar = () => {
    if(user.status !== 'Contrato Ativo'){
      setAlerta({
        type: 'error',
        msg: 'Não é possivel solicitar coleta extra, pois seu contrato não se encontra ativo!',
        show: true,
      });
    }else{
        if(quantidade !== '' & quantidade !== '0' & quantidade !== 0){
          setLoading(true)
          api.post(`/clients/coleta/extra`,
          {
            contrato_id: idContrato,
            data,
            turno: value,
            quantidade,
          }).then(function (response) {
            setLoading(false)
            let { status, message } = response.data;
            if(status === true){
              setAlerta({
                type: 'success',
                msg: "Solicitado com sucesso!",
                show: true,
              });
              handleClose();
              getStart();
            }else{
              setAlerta({
                type: 'error',
                msg: message,
                show: true,
              });
            }
          }).catch(function(error){
            console.log(error)
            setLoading(false)
          });
        }else{
          setAlerta({
            type: 'error',
            msg: "Preencha a quantidade!",
            show: true,
          });
        }
    }
  }
  const Alert = React.forwardRef(function Alert(
      props,
      ref,
  ) {
      return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const handleCloseAlerta = (event, reason) => {
      if (reason === 'clickaway') {
          return;
      }
      setAlerta({
        type: 'error',
        msg: '',
        show: false,
      });
  };
  return (
    <>
      <Fab 
        variant="extended" 
        aria-label="add" 
        style={{
            position: 'absolute', 
            bottom: 16,
            right: 16,
            backgroundColor: "var(--main-bg-color)",
            color: 'var(--main-white-color)'
        }}
        onClick={() => handleShow()}
        >
            <AddIcon sx={{ mr: 1 }} />
            Nova Coleta
        </Fab>

      <Modal show={show} onHide={handleClose} >
        <Modal.Header className={theme.palette.mode === "dark" ? "bg-dark text-white" : null}>
          <Modal.Title>Solicitar Coleta Extra</Modal.Title>
          <div style={{cursor: "pointer", float: "right", display: "flex", alignItems: 'center', height: 35, width: 35}} onClick={() => handleClose()}>
            <IconContext.Provider value={{ color: "#a3a3a3", size: 20 }}>
              <AiOutlineClose />
            </IconContext.Provider>
          </div>
        </Modal.Header>
        <Modal.Body className={theme.palette.mode === "dark" ? "bg-dark text-white" : null}>
          <Stepper activeStep={activeStep}>
            <Step>
              <StepLabel >Preencha as informações</StepLabel>
            </Step>
            <Step>
              <StepLabel >Confirme a solicição</StepLabel>
            </Step>
          </Stepper>
          <div style={{marginTop: 30}} />
          {activeStep === 0 && (
            <div>
              <Typography variant="body2">
                Nome: {user.name}<br />
              </Typography>
              <Typography variant="body2" >
                Endereço: {user.endereco}<br />
              </Typography>
              <Typography variant="body2" >
                Residuo: {user.residuo}<br />
              </Typography>
              <div style={{marginTop: 20}} />
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-BR">
                <DatePicker
                  label="Data"
                  type="date"
                  minDate={dataMinimo}
                  maxDate={dataMaximo}
                  inputFormat='DD/MM/YYYY'
                  sx={{ width: "100%" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={text}
                  onChange={handleChangeData}
                  renderInput={(params) => <TextField type="date" sx={{ width: "100%" }} {...params} />}
                />
              </LocalizationProvider>
              <div style={{marginTop: 20}} />
              <FormControl fullWidth>
                <InputLabel id="turno">Turno</InputLabel>
                <Select
                  labelId="turno"
                  value={value}
                  label="Turno"
                  onChange={handleChangeTurno}
                >
                  {items.map((element, index) => (
                    <MenuItem key={index} disabled={element.disabled} value={element.value}>{element.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <div style={{marginTop: 20}} />
              <FormControl fullWidth variant="outlined">
                <OutlinedInput
                  endAdornment={<InputAdornment position="end">{user.residuo}</InputAdornment>}
                  aria-describedby="quantidade"
                  inputProps={{
                    'aria-label': 'weight',
                  }}
                  value={quantidade}
                  onChange={handleChangeQuantidade}
                />
                <FormHelperText id="quantidade">Unidades</FormHelperText>
              </FormControl>
              <div style={{marginTop: 10}} />
              <Typography variant="body2">Orientações</Typography>
              <div className="caption">1 - Toda e qualquer solicitação deverá ser feita diretamente ao setor responsável e aprovado pelo mesmo, de acordo com a demanda do Grupo Urbam. <br /></div>
              <div className="caption">2 - As coletas extras somente poderão ser solicitadas com pelo menos 24h de antecedência, para um melhor atendimento e logística.<br /></div>
              <div className="caption">3 - Conforme previsão contratual, para toda e qualquer solicitação extra, será  gerado um custo adicional na sua fatura.<br /></div>
              <div className="caption">4 - A coleta extra solicitada não afetará a frequência das coletas previstas em contrato.</div>
            </div>
          )}
           {activeStep === 1 && (
            <>
              <Typography variant="body">Endereço:</Typography>
              <List sx={{ width: '100%', margin: 0, marginTop: -1.5 }}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <LocationOnIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={
                    <Typography variant="body2">
                      {user.name}<br />
                    </Typography>
                  } 
                  secondary={
                    <Typography variant="body2">
                      {user.endereco}<br />
                    </Typography>
                  } />
                </ListItem>
              </List>
              <Typography variant="body">Resíduo:</Typography>
              <List sx={{ width: '100%', margin: 0, marginTop: -1.5 }}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <DeleteSweepIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={
                    <Typography variant="body2">
                      {user.residuo}<br />
                    </Typography>
                  } 
                  secondary={
                    <Typography variant="body2">
                      {quantidade} Unidades<br />
                    </Typography>
                  } />
                </ListItem>
              </List>
              <Typography variant="body">Data/Turno:</Typography>
              <List sx={{ width: '100%', margin: 0, marginTop: -1.5 }}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <AccessTimeFilledIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={
                    <Typography variant="body2">
                      {data}<br />
                    </Typography>
                  } 
                  secondary={
                    <Typography variant="body2">
                      {value}<br />
                    </Typography>
                  } />
                </ListItem>
              </List>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className={theme.palette.mode === "dark" ? "bg-dark text-white" : null}>
          {activeStep === 0 && (
            <div  onClick={() => confirmar()}>
              <Button style={{backgroundColor: "var(--main-bg-color)"}} variant="contained">
                Proximo
              </Button>
            </div>
          )}
          {activeStep === 1 && (
            <>
              <div onClick={() => setActiveStep((prevActiveStep) => prevActiveStep - 1)}>
                <Button style={{backgroundColor: "var(--main-secondy)"}} variant="contained">
                    Voltar
                </Button>
              </div>
              <div  onClick={() => soliticar()} >
                <Button style={{backgroundColor: "var(--main-bg-color)"}} variant="contained">
                    Solicitar
                </Button>
              </div>
            </>
          )}
        </Modal.Footer>
        <Snackbar open={alerta.show} autoHideDuration={6000} onClose={handleCloseAlerta}>
          <Alert onClose={handleCloseAlerta} severity={alerta.type} sx={{ width: '100%' }}>
            {alerta.msg}
          </Alert>
        </Snackbar>
      </Modal>
    </>
  );
}

export default SolicitarColetaExtra;